import React, {useEffect, useRef, useState} from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Checkbox,
  InputLabel
} from '@mui/material';
import DescriptiveQuestionType from '../../Prepostlearning/Assessment/Addquestion/DescriptiveQuestionType';
import MatchingQuestionType from '../../Prepostlearning/Assessment/Addquestion/MatchingQuestionType';
import MultipleQuestionType from '../../Prepostlearning/Assessment/Addquestion/MultipleQuestionType';
import SingleQuestionType from '../../Prepostlearning/Assessment/Addquestion/SingleQuestionType';
import TrueFalseQuestionType from '../../Prepostlearning/Assessment/Addquestion/TrueFalseQuestionType';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useAppContext} from '@context/AppContext';
import {getLMSResultsData} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useOnlineContext} from './OnlineTestContext';
import SelectInput from '@components/form/select-input/SelectInput';
import {Controller, useFieldArray, useForm} from 'react-hook-form';
import {FormControlDiv} from '../../../module-search-filter/ModuleSearchFilterStyle';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import SingleTypeQuestion from './SingleTypeQuestion';
import MultipleTypeQuestion from './MultipleTypeQuestions';
import TrueFalseOnlineQuestionType from './TrueFalseOnlineQuestionType';
import MatchFollowigOnlineQuestion from './MatchFollowigOnlineQuestion';
import DescriptiveOnlineTest from './DescriptiveOnlineTest';
import {LoadingButton} from '@mui/lab';
import FillInTheBlank from './FillInTheBlank';
import { v4 as uuidv4 } from 'uuid';
interface QuestionFormProps {
  // eslint-disable-next-line react/boolean-prop-naming
  open: boolean;
  onClose: () => void;
  onSave: (formData: any) => void;
  handleEditQuestion: any;
}

interface Option {
  value: string;
  label: string;
}

interface MatchChoice {
  id: string;
  Question: string;
  value: string;
}
interface Choice {
  id: string;
  value: string;
}
interface ChildFormMethods {
  submitForm: () => Promise<any>;
}
const QuestionFormOnlineTest: React.FC<QuestionFormProps> = ({
  open,
  onClose,
  onSave,
  handleEditQuestion
}) => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const childFormRef = useRef<ChildFormMethods | null>(null);
  const {onlineData, setOnlineData} = useOnlineContext();
  const {uiFields, setUiFields} = useOnlineContext();
  const {dropDowndata, setDropDownData} = useOnlineContext();
  const {optionsRendered, setOptionsRendered} = useOnlineContext();
  const {questionLoader} = useOnlineContext();
  const {optionsRenderedQuestion, setOptionsRenderedQuestion} =
    useOnlineContext();
  const {screenSave, setScreenSave} = useOnlineContext();
  const [screenLoader, setScreenLoader] = useState(false);
  const [category, setCategory] = useState<number>(1);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(uuidv4());
  const [mark, setMark] = useState<number>(1);
  const [level, setLevel] = useState<number>(1);
  const [tags, setTags] = useState<string>('');
  const [addToBank, setAddToBank] = useState<boolean>(true);
  const [partialMarket, setpartialMarket] = useState<boolean>(true);
  const [questionType, setQuestionType] = useState(1);
  const [singleQuestion, setSingleQuestion] = useState({
    question: '',
    correctAnswer: undefined,
    choices: [
      {id: 1, value: ''},
      {id: 2, value: ''}
    ]
  });

  const [multipleQuestion, setMultipleQuestion] = useState({
    question: '',
    correctAnswers: [] as string[],
    choices: [
      {id: 1, value: ''},
      {id: 2, value: ''}
    ]
  });
  const [trueFalseQuestion, setTrueFalseQuestion] = useState({
    question: '',
    answer: ''
  });
  const [matchQuestion, setMatchQuestion] = useState({
    question: '',
    correctMatches: [] as MatchChoice[],
    additionalChoices: [] as MatchChoice[],
    matchCounter: 0,
    choiceCounter: 0
  });
  const [descriptiveQuestion, setDescriptiveQuestion] = useState({
    question: '',
    enforceWordLimit: false,
    wordLimit: undefined as number | undefined
  });
  React.useEffect(() => {
    const initialFetching = async () => {
      if (uiFields && !optionsRenderedQuestion) {
        setScreenLoader(true);
        const {sql_data} = uiFields['QuestionSetUpForm'];
        try {
          const data: any = {
            sql_data: sql_data,
            operation: 'GETQUESTIONFORMOPTIONS'
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          setDropDownData((prevData: any[]) => {
            const resultData = result.data; // Assuming `result.data` contains the JSON object

            const transformedData = Object.keys(resultData).map(key => ({
              Name: key,
              Values: resultData[key].map((item: any) => ({
                label: item.label,
                value: item.value
              }))
            }));

            return [...(prevData || []), ...transformedData];
          });
          setOptionsRenderedQuestion(true);
          setScreenLoader(false);
        } catch (e) {
          setScreenLoader(false);
          const errMessage = getErrorMessage(e);
          enqueueSnackbar(errMessage, SnackBarConfig.getError());
        }
      }
    };
    initialFetching();
  }, [optionsRenderedQuestion]);
  useEffect(() => {
    if (handleEditQuestion && open) {
      const {
        QuestionType_id,
        QuestionCategoryType_id,
        QuestionMarks_id,
        QuestionDifficultyLevel_id,
        csv_QuestionTags,
        ADDQuestionToQuestionBank,
        id
      } = handleEditQuestion;
      setCategory(QuestionCategoryType_id || 1);
      setMark(QuestionMarks_id || 1);
      setLevel(QuestionDifficultyLevel_id || 1);
      setTags(csv_QuestionTags || '');
      setAddToBank(ADDQuestionToQuestionBank || true);
      setQuestionType(QuestionType_id);
      setCurrentQuestionIndex(id);
    } else {
      setCategory(1);
      setMark(1);
      setLevel(1);
      setTags('');
      setAddToBank(true);
      setQuestionType(1);
      setSingleQuestion({
        question: '',
        correctAnswer: undefined,
        choices: [
          {id: 1, value: ''},
          {id: 2, value: ''}
        ]
      });
      setMultipleQuestion({
        question: '',
        correctAnswers: [] as string[],
        choices: [
          {id: 1, value: ''},
          {id: 2, value: ''}
        ]
      });
      setTrueFalseQuestion({
        question: '',
        answer: ''
      });
      setMatchQuestion({
        question: '',
        correctMatches: [] as MatchChoice[],
        additionalChoices: [] as MatchChoice[],
        matchCounter: 0,
        choiceCounter: 0
      });
      setDescriptiveQuestion({
        question: '',
        enforceWordLimit: false,
        wordLimit: undefined as number | undefined
      });
    }
  }, [handleEditQuestion, open]);

  const resetSingleQuestion = () => {
    setSingleQuestion({
      question: '',
      correctAnswer: undefined,
      choices: [
        {id: 1, value: ''},
        {id: 2, value: ''}
      ]
    });
  };

  const validateMultipleQuestion = () => {
    const {question, correctAnswers, choices} = multipleQuestion;
    if (
      question === '' ||
      correctAnswers.length === 0 ||
      choices[0].value === '' ||
      choices[1].value === ''
    ) {
      alert('Please fill all the fields');
      return false;
    }
    return true;
  };

  const resetMultipleQuestion = () => {
    setMultipleQuestion({
      question: '',
      correctAnswers: [],
      choices: [
        {id: 1, value: ''},
        {id: 2, value: ''}
      ]
    });
  };

  const validateTrueFalseQuestion = () => {
    const {question, answer} = trueFalseQuestion;
    if (question === '' || answer === '') {
      alert('Please fill all the fields');
      return false;
    }
    return true;
  };

  const resetTrueFalseQuestion = () => {
    setTrueFalseQuestion({question: '', answer: ''});
  };

  const validateMatchQuestion = () => {
    const {question, correctMatches, additionalChoices} = matchQuestion;
    if (
      question === '' ||
      correctMatches.length === 0 ||
      additionalChoices.length === 0
    ) {
      alert('Please fill all the fields');
      return false;
    }
    return true;
  };

  const resetMatchQuestion = () => {
    setMatchQuestion({
      question: '',
      correctMatches: [],
      additionalChoices: [],
      matchCounter: 0,
      choiceCounter: 0
    });
  };

  const validateDescriptiveQuestion = () => {
    const {question} = descriptiveQuestion;
    if (question === '') {
      alert('Please fill all the fields');
      return false;
    }
    return true;
  };
  const handleSubmite = () => {
    // Submit data to server
    console.log('Question:');
  };
  const onSubmit = (data: any) => {
    console.log('Form Submitted', data);
  };
  const resetDescriptiveQuestion = () => {
    setDescriptiveQuestion({
      question: '',
      enforceWordLimit: false,
      wordLimit: undefined
    });
  };

  const handleSubmits = (data: any) => {
    let formData;
    //console.log('data', data);
    switch (questionType) {
      case 1:
        formData = {
          QuestionType_id: questionType,
          ...data,
          id: currentQuestionIndex,
          QuestionCategoryType_id: category,
          QuestionMarks_id: mark,
          QuestionDifficultyLevel_id: level,
          csv_QuestionTags: tags,
          ADDQuestionToQuestionBank: addToBank,
          AllowPartialMarking: false,
          sequence: handleEditQuestion?.sequence
        };
        // if (validateSingleQuestion()) {
        onSave(formData);
        setCurrentQuestionIndex(uuidv4());
        resetSingleQuestion();
        // onClose();
        // }
        break;
      case 2:
        formData = {
          QuestionType_id: questionType,
          ...data,
          id: currentQuestionIndex,
          QuestionCategoryType_id: category,
          QuestionMarks_id: mark,
          QuestionDifficultyLevel_id: level,
          csv_QuestionTags: tags,
          ADDQuestionToQuestionBank: addToBank,
          AllowPartialMarking: partialMarket,
          sequence: handleEditQuestion?.sequence
        };
        onSave(formData);
        setCurrentQuestionIndex(uuidv4());
        resetMultipleQuestion();
        // onClose();
        break;
      case 3:
        formData = {
          QuestionType_id: questionType,
          QuestionText: data.QuestionText,
          TrueFalse: data.TrueFalse,
          id: currentQuestionIndex,
          QuestionCategoryType_id: category,
          QuestionMarks_id: mark,
          QuestionDifficultyLevel_id: level,
          csv_QuestionTags: tags,
          ADDQuestionToQuestionBank: addToBank,
          AllowPartialMarking: false,
          sequence: handleEditQuestion?.sequence
        };
        //console.log('formData', formData, formData.TrueFalse, data.TrueFalse);
        onSave(formData);
        setCurrentQuestionIndex(uuidv4());
        resetTrueFalseQuestion();
        // onClose();
        break;
      case 4:
        formData = {
          QuestionType_id: questionType,
          ...data,
          id: currentQuestionIndex,
          QuestionCategoryType_id: category,
          QuestionMarks_id: mark,
          QuestionDifficultyLevel_id: level,
          csv_QuestionTags: tags,
          ADDQuestionToQuestionBank: addToBank,
          AllowPartialMarking: partialMarket,
          sequence: handleEditQuestion?.sequence
        };
        onSave(formData);
        setCurrentQuestionIndex(uuidv4());
        resetMatchQuestion();
        // onClose();
        break;
      case 5:
        formData = {
          QuestionType_id: questionType,
          ...data,
          id: currentQuestionIndex,
          QuestionCategoryType_id: category,
          QuestionMarks_id: mark,
          QuestionDifficultyLevel_id: level,
          csv_QuestionTags: tags,
          ADDQuestionToQuestionBank: addToBank,
          AllowPartialMarking: false,
          sequence: handleEditQuestion?.sequence
        };
        onSave(formData);
        setCurrentQuestionIndex(uuidv4());
        resetDescriptiveQuestion();
        // onClose();
        break;
      case 6:
        formData = {
          QuestionType_id: questionType,
          ...data,
          id: currentQuestionIndex,
          QuestionCategoryType_id: category,
          QuestionMarks_id: mark,
          QuestionDifficultyLevel_id: level,
          csv_QuestionTags: tags,
          ADDQuestionToQuestionBank: addToBank,
          AllowPartialMarking: false,
          sequence: handleEditQuestion?.sequence
        };
        onSave(formData);
        setCurrentQuestionIndex(uuidv4());
        resetDescriptiveQuestion();
        // onClose();
        break;
      default:
        break;
    }
  };
  const handleSave = async () => {
    try{
    if (childFormRef.current) {
      const childData = await childFormRef.current.submitForm();
      if (childData) {
        const completeData = {
          ...childData
        };
        handleSubmits(completeData);
        // onSave(completeData);
        // onClose();
      }
   
    }
     }catch(e){
      console.log("err",e)
    }
  };
  const renderQuestionTypeComponent = () => {
    switch (questionType) {
      case 1:
        return (
          <Box>
            <SingleTypeQuestion
              handleEditQuestion={handleEditQuestion}
              ref={childFormRef}
            />
          </Box>
        );
      case 2:
        return (
          <MultipleTypeQuestion
            handleEditQuestion={handleEditQuestion}
            ref={childFormRef}
          />
        );
      case 3:
        return (
          <TrueFalseOnlineQuestionType
            handleEditQuestion={handleEditQuestion}
            ref={childFormRef}
          />
        );
      case 4:
        return (
          <MatchFollowigOnlineQuestion
            handleEditQuestion={handleEditQuestion}
            ref={childFormRef}
          />
        );
      case 5:
        return (
          <DescriptiveOnlineTest
            handleEditQuestion={handleEditQuestion}
            ref={childFormRef}
          />
        );
      case 6:
        return (
          <FillInTheBlank
            handleEditQuestion={handleEditQuestion}
            ref={childFormRef}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        '& .MuiDialog-paper': {
          minHeight: '91vh',
          minWidth: '105vh',
          overflowY: 'hidden !important',
          maxWidth: '105vh'
        }
      }}>
      <DialogTitle sx={{backgroundColor: '#073B4C', color: 'white'}}>
        Add Question
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          padding: 0,
          overflowY: 'hidden !important',
          borderBottom: 'none'
        }}>
        <Grid
          container
          spacing={2}
          sx={{minHeight: '79vh', width: '100%', m: 0}}>
          <Grid item xs={12} md={3} sx={{backgroundColor: '#073B4C'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Question Type</FormLabel>
              <RadioGroup
                value={questionType}
                onChange={e => setQuestionType(Number(e.target.value))}>
                <FormControlLabel
                  sx={{color: 'white'}}
                  value={1}
                  control={<Radio />}
                  label="Single"
                />
                <FormControlLabel
                  sx={{color: 'white'}}
                  value={2}
                  control={<Radio />}
                  label="Multiple"
                />
                <FormControlLabel
                  sx={{color: 'white'}}
                  value={3}
                  control={<Radio />}
                  label="True or False"
                />
                <FormControlLabel
                  sx={{color: 'white'}}
                  value={4}
                  control={<Radio />}
                  label="Match the following"
                />
                <FormControlLabel
                  sx={{color: 'white'}}
                  value={5}
                  control={<Radio />}
                  label="Descriptive"
                />
                {/* <FormControlLabel
                  sx={{color: 'white'}}
                  value={6}
                  control={<Radio />}
                  label="Fill In Blank"
                /> */}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={9} sx={{paddingRight: '8px'}}>
            <Box
              sx={{
                maxHeight: '76vh',
                overflowY: 'auto'
              }}>
              {renderQuestionTypeComponent()}
              <Card
                variant="outlined"
                sx={{mx: 'auto', padding: '8px', marginTop: '2vh'}}>
                <CardContent>
                  <Typography variant="h6" sx={{mb: 1}}>
                    Question Options
                  </Typography>
                  <FormControl fullWidth>
                    <Grid container sx={{mt: 1}}>
                      <Grid item xs={12} sm={10} md={6}>
                        <FormControl fullWidth margin="normal">
                          <FormControlDiv>
                            <SelectInput
                              enableDefaultOption
                              name="QuestionCategoryType_id"
                              label="Question Category"
                              options={
                                dropDowndata.find(
                                  (item: {Name: string}) =>
                                    item.Name === 'QuestionCategoryType'
                                )?.Values || []
                              }
                              value={category}
                              fullWidth
                              // onOpenCallback={(event: any) =>
                              //   handleLegacyAppChange(event, 'Maximumallowedattempts')
                              // }
                              onChange={(event: any) => {
                                setCategory(Number(event.target.value));
                                // setMaxAttempts(Number(event.target.value));
                                // setState(prevState => ({
                                //   ...prevState,
                                //   formError: ''
                                // }));
                              }}
                              optionValueKey={'value'}
                              optionLabelKey={'label'}
                              fetchOptionsFromOnOpenTrigger
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: '30vh', // Set dropdown max height
                                    overflowY: 'auto' // Enable scrolling
                                  }
                                }
                              }}
                            />
                          </FormControlDiv>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </FormControl>
                  <Box display="flex" mb={2}>
                    <Grid container>
                      <Grid item xs={12} sm={10} md={10}>
                        <FormControl fullWidth margin="normal">
                          <FormControlDiv>
                            <SelectInput
                              enableDefaultOption
                              name="QuestionMarks_id"
                              label="Marks"
                              options={
                                dropDowndata.find(
                                  (item: {Name: string}) =>
                                    item.Name === 'QuestionMarks'
                                )?.Values || []
                              }
                              value={mark}
                              fullWidth
                              // onOpenCallback={(event: any) =>
                              //   handleLegacyAppChange(event, 'Maximumallowedattempts')
                              // }
                              onChange={(event: any) => {
                                setMark(Number(event.target.value));
                                // setMaxAttempts(Number(event.target.value));
                                // setState(prevState => ({
                                //   ...prevState,
                                //   formError: ''
                                // }));
                              }}
                              optionValueKey={'value'}
                              optionLabelKey={'label'}
                              fetchOptionsFromOnOpenTrigger
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: '30vh', // Set dropdown max height
                                    overflowY: 'auto' // Enable scrolling
                                  }
                                }
                              }}
                            />
                          </FormControlDiv>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} sm={10} md={10}>
                        <FormControl fullWidth margin="normal">
                          <FormControlDiv>
                            <SelectInput
                              enableDefaultOption
                              name="QuestionDifficultyLevel_id"
                              label="Level"
                              options={
                                dropDowndata.find(
                                  (item: {Name: string}) =>
                                    item.Name === 'QuestionDifficultyLevel'
                                )?.Values || []
                              }
                              value={level}
                              fullWidth
                              // onOpenCallback={(event: any) =>
                              //   handleLegacyAppChange(event, 'Maximumallowedattempts')
                              // }
                              onChange={(event: any) => {
                                setLevel(Number(event.target.value));
                                // setMaxAttempts(Number(event.target.value));
                                // setState(prevState => ({
                                //   ...prevState,
                                //   formError: ''
                                // }));
                              }}
                              optionValueKey={'value'}
                              optionLabelKey={'label'}
                              fetchOptionsFromOnOpenTrigger
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: '30vh', // Set dropdown max height
                                    overflowY: 'auto' // Enable scrolling
                                  }
                                }
                              }}
                            />
                          </FormControlDiv>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                  {/* <TextField
                    fullWidth
                    label="Tags"
                    variant="outlined"
                    value={tags}
                    onChange={e => setTags(e.target.value)}
                    sx={{mb: 2}}
                  /> */}
                  {/* <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={addToBank} // Ensure a boolean value is always used
                          onChange={e => setAddToBank(e.target.checked)}
                        />
                      }
                      label="Add question to Question Bank"
                    />
                  </FormControl> */}
                  <FormControl fullWidth>
                    {(questionType === 2 || questionType === 4) && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={partialMarket} // Ensure a boolean value is always used
                            onChange={e => {
                              setpartialMarket(e.target.checked);
                            }}
                          />
                        }
                        label="Allow Partial Marking"
                      />
                    )}
                  </FormControl>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          p: 2,
          backgroundColor: '#073B4C'
        }}>
        <LoadingButton
          loading={questionLoader}
          onClick={handleSave}
          variant="contained"
          color="success">
          Save
        </LoadingButton>
        {/* <LoadingButton
          onClick={() => {
            handleSubmite();
            // Additional logic for Save and New
          }}
          color="success"
          variant="contained"
          sx={{ml: 2}}>
          Save add New
        </LoadingButton> */}
        <Button
          color="error"
          variant="contained"
          onClick={() => {
            onClose();
          }}
          sx={{ml: 2}}>
          Cancel
        </Button>
      </Box>
    </Dialog>
  );
};

export default QuestionFormOnlineTest;
